<template>
  <vuetify-aggregator-card
    ref="aggregator"
    :color="color"
    :toolbar-title="toolbarTitle"
    :list-title="listTitle"
    :add-button-hover-text="addButtonHoverText"
    :dialog-max-width="650"
    :navigation-menu="navigationMenu"
    :dialog-toolbar-title="dialogToolbarTitle"
  >
    <v-list two-line slot="card-text" v-if="items.length > 0">
      <transition-group name="list" tag="span">
        <template v-for="(item, index) in items">
          <v-list-tile ripple avatar :key="(index + 2 * 100)" @click="openMessage(index)">
            <v-list-tile-action>
              <v-icon :color="color">inbox</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.quantity }} - {{ item.brand + ' ' + item.model }}
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{ item.type }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ item.installation_price }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="deleteButton">
              <v-tooltip bottom>
                <v-btn slot="activator" icon flat :color="color" @click="askForConfirmation(index)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>{{ deleteIconHoverText }}</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 !== items.length" :inset="false" :key="(index + 1 * 100)"></v-divider>
        </template>
      </transition-group>
    </v-list>

    <v-layout slot="dialog-card-text" row align-center justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <vuetify-form-creator
          v-show="step === 1"
          ref="equipment_fields"
          :columns="'xs12 sm12 md12 lg12'"
          :items="formAggregator"
          v-model="formAggregator"
          @on-change="onChange"
          :validate-on-changed="false"
        ></vuetify-form-creator>
        <vuetify-form-creator
          v-show="step === 2"
          ref="equipment_details"
          :columns="'xs12 sm12 md12 lg12'"
          :items="questions"
          v-model="questions"
          @on-change="onChange"
          :validate-on-changed="false"
        ></vuetify-form-creator>
      </v-flex>
    </v-layout>
    
    <div slot="dialog-card-actions">
      <v-btn
        v-show="step === 2"
        :color="color"
        flat
        @click.native="step = 1"
      >
        Volver
      </v-btn>
      <v-btn
        v-show="step === 1"
        :color="color"
        flat
        @click.native="$refs.equipment_fields.validateForm() ? step = 2 : step = 1"
      >
        Siguente
      </v-btn>
      <v-btn
        v-show="step === 2"
        :color="color"
        flat
        @click.native="addEquipment()"
      >
        {{ confirmButton }}
      </v-btn>
    </div>

    <v-dialog slot="extras" v-model="preview" max-width="600">
      <v-card>
        <v-card-title class="headline">DETALLES DEL EQUIPO</v-card-title>
        <v-card-text>
          <vuetify-form-creator
            ref="equipment_preview"
            :columns="'xs12 sm12 md12 lg12'"
            :items="form"
            v-model="form"
            @on-blur="onChange"
            :validate-on-changed="false"
          ></vuetify-form-creator>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="preview = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <vuetify-dialog-confirm
      slot="extras"
      :headline="dialogConfirmHeadline"
      :text="dialogConfirmText"
      :cancel="cancelButton"
      :confirm="confirmButton"
      @on-cancel-dialog="onDiscardDeletion"
      @on-confirm-dialog="onConfirmDeletion"
      v-model="showConfirmDialog"
    ></vuetify-dialog-confirm>

  </vuetify-aggregator-card>
</template>

<script>
  'use strict'
  import Rule from 'mixins/rule'
  import VuetifyFormCreator from '@/components/vuetify-form-creator/vuetify-form-creator'
  import VuetifyAggregatorCard from '@/layouts/vuetify-aggregator-card'
  import VuetifyDialogConfirm from '@/components/vuetify-dialog-confirm'

  export default {
    name: 'VuetifyEquipmentAggregator',
    mixins: [Rule],
    components:
    {
      VuetifyAggregatorCard,
      VuetifyDialogConfirm,
      VuetifyFormCreator
    },

    props: {
      equipments: {
        type: Array,
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      listTitle: {
        type: String,
        default: null,
        required: true
      },
      deleteButton: {
        type: Boolean,
        default: true,
        required: false
      },
      addButtonHoverText: {
        type: String,
        default: null,
        required: true
      },
      dialogMaxWidth: {
        type: Number,
        default: 600,
        required: false
      },
      dialogToolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      rateId: {
        type: String,
        required: true
      },
      textFieldLabel: {
        type: String,
        default: 'Phone',
        required: false
      },
      textFieldRules: {
        type: Array,
        default: null,
        required: false
      },
      selectLabel: {
        type: String,
        default: 'Type',
        required: false
      },
      equipmentsList: {
        type: Object,
        default: null,
        required: false
      },
      dialogConfirmHeadline: {
        type: String,
        default: 'Delete area',
        required: false
      },
      dialogConfirmText: {
        type: String,
        default: 'Estás a punto de eliminar un área de trabajo',
        required: false
      },
      cancelButton: {
        type: String,
        default: 'Cancel',
        required: false
      },
      confirmButton: {
        type: String,
        default: 'Confirm',
        required: false
      },
      deleteIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      navigationMenu: {
        type: Boolean,
        default: true,
        required: false
      },
      canEdit: {
        type: Boolean,
        default: true,
        required: false
      },
      value: {
        type: Array,
        default: null
      }
    },

    data: () => ({
      items: [],
      dialog: false,
      valid: false,
      step: 1,
      title: '',
      message: '',
      user: '',
      preview: false,
      currentEquipment: null,
      showConfirmDialog: false,
      currentIndex: 0,
      form: [],
      questions: [
        {
          assign_to: 'details',
          type: 'radio-group',
          label: '¿Hay desinstalación? (EXTRA)',
          columns: 'xs12 sm12 md12 lg12',
          value: '',
          item_text: 'quantity_value',
          item_value: 'quantity_id',
          avatars: false,
          options: [
            {
              value: 'Sí',
              label: 'Sí',
              hint: 'ATENCIÓN: Si hay desinstalación, es un extra. Informar al cliente de ello.'
            },
            {
              value: 'No',
              label: 'No'
            }
          ],
          rules: [v => !!v || 'Requerido'],
          required: true,
          autocomplete: true,
          disabled: false,
          chips: true
        },
        {
          assign_to: 'details',
          type: 'radio-group',
          label: '¿Es posible que haya más de 4 metros de instalación?',
          columns: 'xs12 sm12 md12 lg12',
          value: 'No',
          item_text: 'quantity_value',
          item_value: 'quantity_id',
          avatars: false,
          options: [
            {
              value: 'Sí',
              label: 'Sí',
              hint: 'ATENCIÓN: posibles extras a pagar el día de la instalación. Informar al cliente de ello.'
            },
            {
              value: 'No',
              label: 'No'
            }
          ],
          rules: [v => !!v || 'Requerido'],
          required: true,
          autocomplete: true,
          disabled: false,
          chips: true
        },
        {
          assign_to: 'details',
          type: 'radio-group',
          label: '¿Hay preinstalación o tubos existentes empotrados?',
          columns: 'xs12 sm12 md12 lg12',
          value: 'No',
          item_text: 'quantity_value',
          item_value: 'quantity_id',
          avatars: false,
          options: [
            {
              value: 'Sí',
              label: 'Sí',
              hint: 'ATENCIÓN: informar al cliente que a veces es necesario realizar pruebas con nitrógeno, y es un extra. Esto se decidirá el mismo día de la instalación con el cliente, o se puede pedir primero un presupuesto.'
            },
            {
              value: 'No',
              label: 'No'
            }
          ],
          rules: [v => !!v || 'Requerido'],
          required: true,
          autocomplete: true,
          disabled: false,
          chips: true
        },
        {
          assign_to: 'details',
          type: 'radio-group',
          label: '¿Hay ascensor?',
          columns: 'xs12 sm12 md12 lg12',
          value: '',
          item_text: 'quantity_value',
          item_value: 'quantity_id',
          avatars: false,
          options: [
            {
              value: 'Sí',
              label: 'Sí'
            },
            {
              value: 'No',
              label: 'No'
            }
          ],
          rules: [],
          autocomplete: true,
          disabled: false,
          chips: true
        },
        {
          assign_to: 'details',
          type: 'radio-group',
          label: '¿Se necesita escalera larga?',
          columns: 'xs12 sm12 md12 lg12',
          value: '',
          item_text: 'quantity_value',
          item_value: 'quantity_id',
          avatars: false,
          options: [
            {
              value: 'Sí',
              label: 'Sí',
              hint: 'ATENCIÓN: Si se necesita escalera larga, es un extra. Informar al cliente de ello.'
            },
            {
              value: 'No',
              label: 'No'
            },
            {
              value: 'No sabe',
              label: 'No sabe'
            }
          ],
          rules: [v => !!v || 'Requerido'],
          required: true,
          autocomplete: true,
          disabled: false,
          chips: true
        }
      ],
      quantity: {
        type: 'select',
        ref: 'quantity',
        columns: 'xs12 sm12 md12 lg12',
        required: true,
        label: 'Cantidad',
        items: [
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9'
        ],
        value: '1',
        autocomplete: true
      },
      brand: {
        type: 'select',
        ref: 'brand',
        columns: 'xs12 sm6 md6 lg6',
        required: true,
        label: 'Marca',
        item_text: undefined,
        item_value: undefined,
        items: [],
        value: undefined
      },
      model: {
        type: 'select',
        ref: 'model',
        columns: 'xs12 sm6 md6 lg6',
        required: true,
        label: 'Modelo',
        item_text: 'seller_name',
        item_value: 'seller_id',
        items: [],
        value: undefined
      },
      installationType: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: [
          'required'
        ],
        editable: true,
        required: true,
        label: 'Tipo de instalación',
        disabled: true,
        value: ''
      },
      installationPrice: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: [
          'required'
        ],
        editable: true,
        required: true,
        label: 'Importe a cobrar',
        disabled: true,
        value: ''
      },
      indoorUnit1: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: [
          'required'
        ],
        editable: true,
        required: true,
        label: 'Modelo unidad interior 1',
        disabled: true,
        value: ''
      },
      indoorUnit2: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: [
          'required'
        ],
        editable: true,
        required: true,
        label: 'Modelo unidad interior 2',
        disabled: true,
        value: ''
      },
      duration: {
        type: 'hidden',
        columns: 'xs12 sm12 md12 lg12',
        rules: [
          'required'
        ],
        editable: false,
        required: true,
        label: 'Duración de la instalación',
        disabled: true,
        value: ''
      },
      paymentMethod: {
        type: 'select',
        ref: 'paymentMethod',
        columns: 'xs12 sm6 md6 lg6',
        required: true,
        label: 'Forma de pago',
        items: [
          'Se pagará I.B. al instalador',
          'Se ha pagado I.B. en tienda'
        ],
        value: '',
        autocomplete: true
      },
      hasBeenPaid: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: [
          'required'
        ],
        editable: true,
        required: true,
        label: 'Ha pagado',
        disabled: true,
        value: ''
      },
      formAggregator: [],
      equipmentType: null,
      equipmentTitle: null,
      equipmentMsg: null
    }),

    created () {
      this.items = this.equipments
      this.formAggregator = []
      this.formAggregator.push(this.quantity)
      this.formAggregator.push(this.brand)
      this.formAggregator.push(this.model)
      this.installationType.rules = this.setRules(this.installationType.rules)
      this.formAggregator.push(this.installationType)
      this.installationPrice.rules = this.setRules(this.installationPrice.rules)
      this.formAggregator.push(this.installationPrice)
      this.indoorUnit1.rules = this.setRules(this.indoorUnit1.rules)
      this.formAggregator.push(this.indoorUnit1)
      this.indoorUnit2.rules = this.setRules(this.indoorUnit2.rules)
      this.formAggregator.push(this.indoorUnit2)
      this.formAggregator.push(this.paymentMethod)
      this.hasBeenPaid.rules = this.setRules(this.hasBeenPaid.rules)
      this.formAggregator.push(this.hasBeenPaid)
    },

    watch: {
      equipmentTypes: {
        handler: function (newVal, oldVal) {
          this.types = newVal
          this.equipmentType = this.types[0]
        },
        deep: true
      },

      equipmentsList: {
        handler: function (newVal, oldVal) {
          this.brand.item_text = newVal.item_text_3 || undefined
          this.brand.item_value = newVal.item_text_3 || undefined
          this.brand.items = newVal.items || []
          this.brand.value = undefined
          this.model.item_text = newVal.item_text_4 || undefined
          this.model.item_value = newVal.item_text_value || undefined
        },
        deep: true
      },

      equipments: {
        handler: function (newVal, oldVal) {
          this.items = newVal
        },
        deep: true
      },

      items: {
        handler: function (newVal, oldVal) {
          this.$emit('update:value', newVal)
        },
        deep: true
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      askForConfirmation (index) {
        this.currentIndex = index
        this.showConfirmDialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange (newVal, oldVal, item, isValid) {
        if (newVal && item.ref === 'brand') {
          this.model.items = []
          this.installationType.value = ''
          this.indoorUnit1.value = ''
          this.indoorUnit2.value = ''
          this.duration.value = ''
          this.installationPrice.value = ''
          this.paymentMethod.value = ''
          this.hasBeenPaid.value = ''
          this.equipmentsList.items.forEach((item, index) => {
            let brand = item[this.equipmentsList.item_text_3]
            if (brand === newVal) {
              this.model.items.push({
                [this.equipmentsList.item_text_4]: item[this.equipmentsList.item_text_4]
              })
              this.currentEquipment = item
            }
          })
        } else if (newVal && this.currentEquipment && item.ref === 'model') {
          newVal = newVal[this.equipmentsList.item_text_4]
          this.equipmentsList.items.forEach((item, index) => {
            let model = item[this.equipmentsList.item_text_4]
            if (model === newVal) {
              this.currentEquipment = item
            }
          })
          this.installationType.value = this.currentEquipment[this.equipmentsList.item_text_12]
          this.indoorUnit1.value = this.currentEquipment[this.equipmentsList.item_text_5]
          this.indoorUnit2.value = this.currentEquipment[this.equipmentsList.item_text_6]
          this.duration.value = this.currentEquipment[this.equipmentsList.item_text_17]
          if (this.rateId === '1') {
            this.installationPrice.value = this.currentEquipment[this.equipmentsList.item_text_14] + '€ (IVA no incluido)'
          } else if (this.rateId === '2') {
            this.installationPrice.value = this.currentEquipment[this.equipmentsList.item_text_15] + '€ (IVA no incluido)'
          } else if (this.rateId === '3') {
            this.installationPrice.value = this.currentEquipment[this.equipmentsList.item_text_16] + '€ (IVA no incluido)'
          }
        } else if (newVal && item.ref === 'paymentMethod') {
          this.paymentMethod.value = newVal
          if (newVal === 'Se pagará I.B. al instalador') {
            this.hasBeenPaid.value = '¡No se ha pagado la I.B.!'
          } else {
            this.hasBeenPaid.value = 'I.B. ' + this.currentEquipment[this.equipmentsList.item_text_12]
          }
        } else if (newVal && item.ref === 'quantity') {
          this.quantity.value = newVal
        } else if (newVal && (item.ref === 'serial_indoor_unit_1' || item.ref === 'serial_indoor_unit_2' || item.ref === 'serial_outdoor_unit_1')) {
          this.items[0][item.ref] = newVal
          this.$emit('on-add-equipment', this.items[0])
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      compare (a, b) {
        if (a.order < b.order) {
          return -1
        }
        if (a.order > b.order) {
          return 1
        }
        return 0
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeEquipment (equipmentIndex) {
        let i = 0
        let form = []
        let equipment = this.items[equipmentIndex]
        for (let key in equipment) {
          form[i] = {}
          form[i].label = key
          form[i].columns = 'xs12 sm6 md6 lg6'
          form[i].editable = true
          form[i].disabled = true
          form[i].type = 'text-field'
          form[i].value = equipment[key]
          switch (key) {
            case 'id':
              form.splice(i, 1)
              break
            case 'type':
              form[i].order = 2
              form[i].label = 'Tipo de equipo'
              break
            case 'brand':
              form[i].order = 3
              form[i].label = 'Marca'
              break
            case 'model':
              form[i].order = 4
              form[i].label = 'Modelo'
              break
            case 'indoor_unit_1':
              form[i].order = 5
              form[i].label = 'Modelo U.I.1'
              break
            case 'indoor_unit_2':
              form[i].order = 7
              form[i].label = 'Modelo U.I.2'
              break
            case 'outdoor_unit_1':
              form[i].order = 9
              form[i].label = 'Modelo U.E.1'
              break
            case 'serial_indoor_unit_1':
              form[i].order = 6
              form[i].disabled = false
              form[i].editable = false
              form[i].type = (this.canEdit) ? 'text-field' : 'plain-text'
              form[i].ref = 'serial_indoor_unit_1'
              form[i].hint = 'Pulsa enter para agregar'
              form[i].tooltip = 'Pulsa para editar'
              form[i].label = 'Número de serie U.I.1'
              break
            case 'serial_indoor_unit_2':
              form[i].order = 8
              form[i].disabled = false
              form[i].editable = false
              form[i].type = (this.canEdit) ? 'text-field' : 'plain-text'
              form[i].ref = 'serial_indoor_unit_2'
              form[i].hint = 'Pulsa enter para agregar'
              form[i].tooltip = 'Pulsa para editar'
              form[i].label = 'Número de serie U.I.2'
              break
            case 'serial_outdoor_unit_1':
              form[i].order = 10
              form[i].disabled = false
              form[i].editable = false
              form[i].type = (this.canEdit) ? 'text-field' : 'plain-text'
              form[i].ref = 'serial_outdoor_unit_1'
              form[i].hint = 'Pulsa enter para agregar'
              form[i].tooltip = 'Pulsa para editar'
              form[i].label = 'Número de serie U.E.1'
              break
            case 'refrigerant_type':
              form[i].order = 11
              form[i].label = 'Tipo de refrigerante'
              break
            case 'refrigerant_quantity':
              form[i].order = 12
              form[i].label = 'Cantidad de refrigerante'
              break
            case 'frigories':
              form[i].order = 13
              form[i].label = 'Frigorías'
              break
            case 'quantity':
              form[i].order = 1
              form[i].label = 'Cantidad'
              break
            case 'power_source':
              form[i].order = 14
              form[i].label = 'Fuente de potencia'
              break
            case 'installation_price':
              form[i].order = 18
              form[i].label = 'Precio instalación (IVA NO INCLUIDO)'
              form[i].columns = 'xs12 sm12 md12 lg12'
              form[i].value = equipment[key] + '€'
              break
            case 'payment_method':
              form[i].order = 15
              form[i].label = 'Forma de pago'
              break
            case 'has_been_paid':
              form[i].order = 16
              form[i].label = 'Ha pagado'
              break
            case 'installation_type':
              form[i].order = 17
              form[i].label = 'Tipo de instalación'
              form[i].columns = 'xs12 sm12 md12 lg12'
              break
            case 'duration':
              form[i].order = 19
              form[i].label = 'Duración de la instalación'
              form[i].columns = 'xs12 sm12 md12 lg12'
              form[i].value = equipment[key] + 'h'
              break
            case 'question_1':
              form[i].order = 20
              form[i].label = '¿Hay desinstalación? '
              form[i].columns = 'xs12 sm12 md12 lg12'
              break
            case 'question_2':
              form[i].order = 22
              form[i].label = '¿Es posible que haya más de 4 metros de instalación?'
              form[i].columns = 'xs12 sm12 md12 lg12'
              break
            case 'question_3':
              form[i].order = 23
              form[i].label = '¿Hay preinstalación o tubos existentes empotrados?'
              form[i].columns = 'xs12 sm12 md12 lg12'
              break
            case 'question_4':
              form[i].order = 24
              form[i].label = '¿Hay ascensor?'
              form[i].columns = 'xs12 sm12 md12 lg12'
              break
            case 'question_5':
              form[i].order = 25
              form[i].label = '¿Se necesita escalera larga?'
              form[i].columns = 'xs12 sm12 md12 lg12'
              break
          }
          i++
        }
        form.sort(this.compare)
        this.form = form
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDiscardDeletion (ref) {
        this.showConfirmDialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onConfirmDeletion () {
        this.showConfirmDialog = false
        this.deleteEquipment()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteEquipment () {
        this.items.splice(this.currentIndex, 1)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openMessage (index) {
        if (!this.showConfirmDialog) {
          this.normalizeEquipment(index)
          this.preview = true
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openDialog () {
        this.$refs.aggregator.dialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      closeDialog () {
        this.$refs.aggregator.dialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addEquipment () {
        if (this.$refs.equipment_details.validateForm()) {
          this.closeDialog()
          console.error(this.currentEquipment)
          console.error(this.currentEquipment[this.equipmentsList.item_text_9])
          let item = {
            id: this.currentEquipment[this.equipmentsList.item_value],
            installation_type_id: this.currentEquipment[this.equipmentsList.item_text_18],
            type: this.currentEquipment[this.equipmentsList.item_text_2],
            brand: this.currentEquipment[this.equipmentsList.item_text_3],
            model: this.currentEquipment[this.equipmentsList.item_text_4],
            indoor_unit_1: this.currentEquipment[this.equipmentsList.item_text_5],
            indoor_unit_2: this.currentEquipment[this.equipmentsList.item_text_6],
            outdoor_unit_1: this.currentEquipment[this.equipmentsList.item_text_7],
            serial_indoor_unit_1: '',
            serial_indoor_unit_2: '',
            serial_outdoor_unit_1: '',
            refrigerant_type: this.currentEquipment[this.equipmentsList.item_text_9],
            refrigerant_quantity: this.currentEquipment[this.equipmentsList.item_text_10],
            frigories: this.currentEquipment[this.equipmentsList.item_text_11],
            quantity: this.quantity.value,
            power_source: this.currentEquipment[this.equipmentsList.item_text_8],
            installation_price: this.installationPrice.value,
            payment_method: this.paymentMethod.value,
            has_been_paid: this.hasBeenPaid.value,
            installation_type: this.currentEquipment[this.equipmentsList.item_text_12],
            question_1: this.questions[0].value,
            question_2: this.questions[1].value,
            question_3: this.questions[2].value,
            question_4: this.questions[3].value,
            question_5: this.questions[4].value,
            duration: this.currentEquipment[this.equipmentsList.item_text_17]
          }
          this.$refs.equipment_fields.reset()
          this.$refs.equipment_details.reset()
          this.currentEquipment = null
          this.items.push(item)
          this.$emit('on-add-equipment', item)
          this.$emit('on-delete-equipment', this.currentIndex, this.items[this.currentIndex])
        }
      }
    }
  }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/vuetify-equipment-aggregator.vue